<template style="">
  <div class="Propagate_look">
    <h2>{{ data.materialName }}</h2>
    <div style="width: 90%;margin-left: 5%;padding-top: 30px;height: 40px;">
      <span style="float: left;font-size: 16px;">编辑人：{{ data.creator }}   发布时间: {{ data.releaseTime }}</span>
      <!-- <p v-for="(item,i) in  data.labels" :key="i">{{item}}aaaaaa</p> -->
      <span v-if="data.labels && data.labels.length > 0" style="float: left;font-size: 16px;margin-left:50px">标签： <span style="margin-left:10px" v-for="(item,i) in  data.labels" :key="i">{{ item }}</span> </span>
    </div>

    <div v-if="Type == '1' || Type == '2'" style="text-align: center;padding-top: 50px;">
      <video id="video1" width="677" height="340" controls  :poster="data.materialCover">
        <source :src="url" type="video/mp4" />
        <source :src="url" type="video/avi" />
        <source :src="url" type="video/mov" />
      </video>
    </div>

    <div v-if="Type == '3'" style="text-align: center;padding-top: 50px;">
      <img style="width: 677px;width: 340px;" :src="url" alt="">
    </div>

    <div v-if="Type == '4'" style="text-align: center;padding-top: 50px;">
      <img style="width: 677px;width: 340px;" :src="data.materialCover" alt="">
      <div class="richText" v-html="data.richTextContent"></div>
    </div>

    <div v-if="Type == '5'" style="text-align: center;padding-top: 50px;">
      <img style="width: 677px;width: 340px;" :src="url" alt="">
      <div style="text-align: left;padding-top: 50px;margin-left:10%">
        <p>轮播顺序：{{ data.lineNumber }}</p>
        <p style="padding-top: 20px;">内容跳转链接：{{ data.jumpContentLink }}</p>
      </div>
    </div>

    <div v-if="data.copyrightStatement" style="padding: 20px;margin-left:50px">版权声明：{{data.copyrightStatement}}</div>
    
    <!-- 1、已发布 2、已通过 3、已驳回 4、需修订 5、草稿 6、正在审核 -->
    <div style="text-align:center;padding-top:50px;">
      <!-- <el-button v-if="data.status == 6 && (Source == 1 || Source == 2)" type="primary" @click="gg(2, data.materialType)">通过</el-button>
      <el-button v-if="data.status == 6 && (Source == 1 || Source == 2)" type="primary" @click="bhdialog(data.materialType)">驳回</el-button> -->
      <!-- <el-button v-if="data.status == 6 && (Source == 1 || Source == 2)" type="primary" @click="gg(3, data.materialType)">驳回</el-button> -->
      <el-button type="primary" @click="gg(10)">返回</el-button>
    </div>

    <div v-if="status == '已驳回'">
      <span style="margin-left:20px">驳回理由：{{data.reasonRejection}}</span>
      <br>
      <!-- <span style="margin-left:20px;margin-top:14px;display: block;">修改意见</span>
      <ul class="vul">
        <li v-for="(item,i) in data.modifySuggests" :key="i" @click="loxq(item)">
          <img :src="item" alt="">
        </li>
      </ul> -->
    </div>

    <!-- status：发布状态  1、已发布 2、已通过 3、已驳回 4、需修订 5、草稿；6、正在审核 

     SourceFlg来源区分 0:内容素材，1：轮播图 -->

    <!-- //状态 1.发布 2.通过 3.驳回 4.修订 -->
    <el-dialog title="驳回" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <span>驳回原因:</span>
      <el-input style="margin-top:14px;margin-bottom:14px" type="textarea" :rows="2" placeholder="请输入驳回原因" v-model="bhyy"></el-input>
      <span style="">修改意见</span>
      <el-upload style="margin-top:14px;" class="upload-demo" :on-change="handleChange" action="" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" list-type="picture">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
      </el-upload>
      <el-button type="primary" @click="qutj()" style="margin-top:20px;margin-left:180px">确定</el-button>
    </el-dialog>


    <el-dialog title="修改意见" :visible.sync="dialogVisible2" width="50%" :before-close="handleClose">
      <div style="width: 500px;height: 400px;">
        <img :src="imgurl" alt="" style="width: 100%;">
      </div>
    </el-dialog>

    
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible:false,
      dialogVisible2:false,
      imgurl:"",
      bhyy:'',
      fileList: [],
      filedata: [],
      wmaterialType:'',
      materialKey: '',
      Type: '',
      data: [],
      url: '',
      Source: '',
      status:''
    }
  },
  mounted() {
    this.status = [this.$route.query.status][0];
    this.materialKey = [this.$route.query.materialKey][0];
    this.Type = [this.$route.query.Type][0];
    this.Source = [this.$route.query.Source][0];
    this.$Http_Post('management/getContentDetails', { MaterialKey: this.materialKey }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;  
        this.url = this.data.materialPath;

        document.getElementById("video1").load();
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  methods: {
    loxq(url){
      this.dialogVisible2 = true
      this.imgurl = url
    },
    bhdialog(row){
      this.dialogVisible = true;
      this.wmaterialType = row;
    },
    handleRemove(file, fileList) {
      if(this.filedata.length <=1){
        this.filedata = []
      }else{
        for(var i = 0;i < this.filedata.length;i++){
          if(file.name == this.filedata[i].name){
            this.filedata.splice(i,1)
          }
        }
      }
      this.fileList = fileList
    },
    handlePreview(file) {
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    handleChange(file, fileList){
      this.fileList.push({
        name:file.name,
        url:file.url
      })
      this.filedata.push(file)
    },
    qutj(){
      this.$Http_Post('management/contentPublishOperate', { MaterialKey: this.materialKey, Type: 3, MaterialType: this.wmaterialType,ReasonRejection: this.bhyy}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          var from = new FormData();
          from.append('materialKey', this.materialKey);
          this.filedata.forEach(item => {from.append('files', item.raw)})
          this.$Http_Post('management/multipleImageUploads', from).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.$router.go(-1);
            } else {
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    gg(Type, MaterialType) {//通过
      if (Type == 10) {
        this.$router.go(-1);
      } else {
        this.$Http_Post('management/contentPublishOperate', { MaterialKey: this.materialKey, Type: Type, MaterialType: MaterialType }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.$router.push({
              path: '/propagate/index',
            })
          } else {
            this.loading = false;
            this.Global.request_failure(res.Message);
          }
        })
      }
    },
  },
}
</script>
<style>
  .Propagate_look{background-color: #fff;min-height: 100%;width: 100%;padding-bottom: 30px;}
  .Propagate_look h2{font-size: 28px;text-align: center;padding-top: 30px;}
  .vul li{float: left;width: 220px;height: 200px;margin-left: 24px;margin-top: 20px;}
  .vul li img{width: 100%;}
  .richText{width: 640px;display: block;margin: auto;}
</style>
